import type { Auth0ContextInterface } from '@auth0/auth0-react';

export type Auth0Like = Pick<
    Auth0ContextInterface,
    'getAccessTokenSilently' | 'loginWithRedirect'
>;

const isLoginRequiredError = (e: unknown): boolean => {
    if (!e || typeof e !== 'object') return false;
    const err = e as { error?: string; message?: string };
    const code = err.error || err.message || '';
    return code === 'login_required' || /^login.required$/i.test(code);
};

export async function safeGetAccessToken(auth0: Auth0Like): Promise<string | null> {
    try {
        return await auth0.getAccessTokenSilently();
    } catch (e) {
        if (isLoginRequiredError(e)) {
            const returnTo = window.location.pathname + window.location.search;
            await auth0.loginWithRedirect({ appState: { returnTo } });
            return null;
        }
        throw e;
    }
}
